import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    this.adjustOverlayOffset();
  }

  adjustOverlayOffset() {
    const overlayHeight = this.element.getBoundingClientRect().height;
    document.body.style.marginBottom = `${overlayHeight + 40}px`;
  }

  disconnect() {
    document.body.style.marginBottom = 0;
  }
}
